// File: src/api/DashboardApi/Dashboard.js
import { getData } from "../apiClient";

const API_URL = "dashboard";

// GET /api/v1/dashboard
export const GetDashboardData = async (signal = null) => {
  try {
    const result = await getData(`/${API_URL}/`, {}, {}, signal);
    return { success: true, ...result };
  } catch (error) {
    console.error("Dashboard API error:", error);
    return { success: false, error: error.message };
  }
};

// GET /api/v1/dashboard/today-list (Paginated)
export const GetTodayBookingList = async ({ page = 1, limit = 10, search = "" }, signal = null) => {
  try {
    const queryParams = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      search: search,
    });

    const result = await getData(`/${API_URL}/today-list/?${queryParams}`, {}, {}, signal);
    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error("Today Booking List API error:", error);
    return {
      success: false,
      ...error,
    };
  }
};
